import ToggleDropdown from '../reused-components/SidebarTabs';
import AddProducts from '../reused-components/AddProducts';
import Profile from '../reused-components/Profile';
import smlogo from '../../img/sm-logo.svg';
import profileImage from '../../img/user-profile.png';
import React, {useEffect, useState} from "react";
import TelemetryFormBlock from "../reused-components/FormBlock";
import Avatar from "../reused-components/Avatar";
import {fetchUser, updateVerification, fetchUserNotes, addUserNote, updateUserNote, deleteUserNotes} from "../../services/apiService";
import {useParams} from "react-router";
import SitesTable from "../tables/SitesTable";
import ProductEventsLogTable from "../tables/ProductEventsLogTable";
import TelemetryAccordion from "../reused-components/Accordian";
import DarkModeSwitch from "../reused-components/ToggleDarkMode";
import addNoteIcon from '../../img/add-icon.svg';
import EmailLogsTable from "../tables/EmailLogsTable";

export default function UserDetail() {
    document.title = "Users | Telemetry";
    const {userId} = useParams();
    const [userDetails, setUserDetails] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);
    const [userNotes, setUserNotes] = useState('');
    const [showAddNoteModal, setShowAddNoteModal] = useState(false);
    const [noteInput, setNoteInput] = useState('');
    const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseData = await fetchUser(userId);
                setUserDetails(responseData);
                const notesData = await fetchUserNotes(userId);
                if (notesData && notesData.data && notesData.data.note) {
                    setUserNotes(notesData.data.note);
                    setNoteInput(notesData.data.note);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();

    }, [userId]);

    const handleEmailVerificationToggle = async (e) => {
        try {
            setIsUpdating(true);
            const updatedUserDetails = {
                ...userDetails,
                verification: e.target.checked
            };
            await updateVerification(userId, { verification: e.target.checked });
            setUserDetails(updatedUserDetails);
        } catch (error) {
            console.error('Error updating email verification:', error);
            // Revert the toggle if the update fails
            e.target.checked = !e.target.checked;
        } finally {
            setIsUpdating(false);
        }
    };

    const handleAddNoteClick = () => {
        setShowAddNoteModal(true);
    };

    const handleCloseAddNoteModal = () => {
        setShowAddNoteModal(false);
        // If noteInput is empty, clear userNotes as well (implies deletion or empty note)
        if (!noteInput.trim()) {
            setUserNotes('');
        }
    };

    const handleNoteInputChange = (e) => {
        setNoteInput(e.target.value);
    };

    const handleNoteBlur = async () => {
        try {
            if (userNotes && noteInput.trim() !== userNotes.trim()) { // Update existing note
                if (noteInput.trim() === '') { // If note becomes empty, delete it
                    await deleteUserNotes(userId);
                    setUserNotes('');
                    setNoteInput('');
                } else {
                    await updateUserNote(userId, noteInput);
                    setUserNotes(noteInput);
                }
            } else if (!userNotes && noteInput.trim() !== '') { // Add new note
                await addUserNote(userId, noteInput);
                setUserNotes(noteInput);
            }
        } catch (error) {
            console.error('Error updating note:', error);
        }
        setShowAddNoteModal(false);
    };

    const handleDeleteNotes = () => {
        setShowDeleteConfirmationModal(true);
    };

    const confirmDeleteNotes = async () => {
        try {
            await deleteUserNotes(userId);
            setUserNotes('');
            setNoteInput('');
        } catch (error) {
            console.error('Error deleting notes:', error);
        } finally {
            setShowDeleteConfirmationModal(false);
        }
    };

    const cancelDeleteNotes = () => {
        setShowDeleteConfirmationModal(false);
    };

    return (
        <div className="telemetry-page-wrapper">
            <header className="telemetry-header">
                <div className="telemetry-logo-section">
                    <a href="#"><img src={smlogo} alt="Telemetry"/></a>
                </div>
                <div className="telemetry-top">
                    <h1>Users</h1>
                    <div className="telemetry-top-right">
                        <DarkModeSwitch />
                        <AddProducts/>
                        <Profile image={profileImage}/>
                    </div>
                </div>
            </header>
            <main className="telemetry-main">
                <aside className="telemetry-sidebar">
                    <ToggleDropdown tabactive={1} tabactive2={1}/>
                </aside>
                <section className="telemetry-content">
                    <div className="telemetry-user-details-tab">
                        <div className="telemetry-setting-tab-content">
                            <div className="telemetry-setting-box">
                                <h2>Profile Information</h2>
                                <div className="telemetry-box-ov">
                                    <Avatar/>
                                    <div className="telemetry-setting-block-2">
                                        <TelemetryFormBlock
                                            label="First"
                                            inputType="readonly"
                                            name="first"
                                            id="first"
                                            value={userDetails?.first_name}
                                            disabled={true}
                                        />
                                        <TelemetryFormBlock
                                            label="Last"
                                            inputType="text"
                                            name="last"
                                            id="last"
                                            value={userDetails?.last_name}
                                            disabled={true}
                                        />
                                        <TelemetryFormBlock
                                            label="Email"
                                            inputType="text"
                                            name="website"
                                            id="website"
                                            value={userDetails?.email}
                                            disabled={true}
                                        />
                                        <TelemetryFormBlock
                                            label="ID"
                                            inputType="text"
                                            name="id"
                                            id="id"
                                            value={userDetails?.id}
                                            disabled={true}
                                        />
                                    </div>
                                </div>

                                <div className="telemetry-email-verification">
                                        <label>Email Verified</label>
                                        <div className="toggle-switch">
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    id="emailVerified"
                                                    checked={userDetails?.email_verification}
                                                    onChange={handleEmailVerificationToggle}
                                                    disabled={isUpdating}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                </div>

                                <div className="telemetry-add-note-section">
                                    {userNotes ? (
                                        <div className="telemetry-notes-display">
                                            <label>Notes</label>
                                            <textarea
                                                className="telemetry-notes-textarea"
                                                value={noteInput}
                                                onChange={handleNoteInputChange}
                                                onBlur={handleNoteBlur}
                                            ></textarea>
                                            <button className="telemetry-delete-notes-btn" onClick={handleDeleteNotes}>Delete Notes</button>
                                        </div>
                                    ) : (
                                        <button className="telemetry-add-note-btn" onClick={handleAddNoteClick}>
                                            <img src={addNoteIcon} alt="Add Note" style={{ width: '16px', height: '16px' }} />
                                            Add Note
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {showAddNoteModal && (
                        <div className="telemetry-modal-overlay">
                            <div className="telemetry-add-note-modal">
                                <h2>Add Note</h2>
                                <textarea
                                    placeholder="Type your note here..."
                                    value={noteInput}
                                    onChange={handleNoteInputChange}
                                    onBlur={handleNoteBlur}
                                ></textarea>
                                <div className="telemetry-modal-actions">
                                    <button className="telemetry-cancel-btn" onClick={handleCloseAddNoteModal}>Cancel</button>
                                    <button className="telemetry-add-note-btn" onClick={handleNoteBlur}>Add Note</button>
                                </div>
                            </div>
                        </div>
                    )}

                    <TelemetryAccordion title={"Sites"}>
                        <SitesTable paginationPerPage={10} userId={userId}/>
                    </TelemetryAccordion>

                    <TelemetryAccordion title={"Email Logs (30-day history)"}>
                        <EmailLogsTable paginationPerPage={10} userId={userId}/>
                    </TelemetryAccordion>

                    <TelemetryAccordion title={"Events & Webhooks"}>
                        <ProductEventsLogTable paginationPerPage={10} type={'all'} userId={userId}/>
                    </TelemetryAccordion>

                    {showDeleteConfirmationModal && (
                        <div className="telemetry-modal-overlay">
                            <div className="telemetry-add-note-modal">
                                <h2>Confirm Deletion</h2>
                                <p>Are you sure you want to delete this note?</p>
                                <div className="telemetry-modal-actions">
                                    <button className="telemetry-cancel-btn" onClick={cancelDeleteNotes}>No</button>
                                    <button className="telemetry-add-note-btn" onClick={confirmDeleteNotes}>Yes</button>
                                </div>
                            </div>
                        </div>
                    )}
                </section>
            </main>
        </div>
    );
}
  